import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

Object.assign(columnsStyles, {
    ...columnsStyles,
    container: {
        gap: 50,
        css: css`
            ${GridOffset} {
                justify-content: space-between;
                margin-top: 0;
                > ${GridItemStyle} {
                    padding-top: 0;
                    //margin-top: 25px;
                }
            }
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 9, 9, 9],
    },
    rightColumnTableViewGridItem: {
        width: [12, 12, 9, 9, 9],
    },
    leftColumnTableViewGridItem: {
        width: [12, 12, 3, 3, 3],
    },
});
